import { dataHooks } from '@wix/data-hooks'

export const welcomeV2DataHooks = dataHooks<{
  title: {}
  subtitle: {}
  disclaimer: {}
  skip: {}
  next: {}
  radio: { optionKey: string }
}>('welcome-v2')
